import { render, staticRenderFns } from "./IModal.vue?vue&type=template&id=1e1de226&scoped=true&"
import script from "./IModal.vue?vue&type=script&lang=js&"
export * from "./IModal.vue?vue&type=script&lang=js&"
import style0 from "./IModal.vue?vue&type=style&index=0&id=1e1de226&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1de226",
  null
  
)

export default component.exports